<template>
    <TransactionInput :action="action" :transaction-i-d="transactionID" :draft-i-d="draftID"> </TransactionInput>
</template>


<script>
import TransactionInput from "../../components/TransactionInput"
export default {
	name: "AddTransaction",
	components: {TransactionInput},
	data(){
		return{
			action:"transaction" ,
			transactionID:null,
			draftID:null,
		}
	}
}
</script>
